module.exports = __webpack_public_path__ + "img/aesforumthaibadge-sample-badge.10939014.png";